import { Injectable } from '@angular/core';
import { MyOrganizationFacade } from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class TeamDetailsDataGridService {
  event: any;
  teamDetailsPayload: any;
  editTeamsTeamMembership = new Subject<[any, any, any, any]>();
  teamsTeamMembershipData$ = this.editTeamsTeamMembership.asObservable();

  deleteTeamsTeamMembership = new Subject<[any]>();
  deleteTeamsTeamMembershipData$ = this.deleteTeamsTeamMembership.asObservable();
  constructor(private swalService: SwalService) {}

  getTeamsDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'Id',
      headerName: 'Id',
      field: 'Id',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'UserName',
      headerName: 'User name',
      field: 'userName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        !params.data.isSystem && (cellElement.style.cursor = 'pointer');
        !params.data.isSystem && (cellElement.style.textDecoration = 'underline');
        cellElement.innerHTML = `${cellValue}`;
        if (!params.data.isSystem) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          !params.data.isSystem &&
            this.editTeamsTeamMembership.next([
              params.data.id,
              params.data.teamId,
              'Edit team membership',
              params.data.organizationId,
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'EmailId',
      headerName: 'Login ID (EMAIL)',
      field: 'emailId',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RoleName',
      headerName: 'Role',
      field: 'roleName',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showEdit: true,
        showDelete: true,
        value: 'manageTeams',
        deleteData: (data: any) => {
          this.deleteConfirmation(data.id);
        },
        editData: (data: any) => {
          this.editTeamsTeamMembership.next([
            data.id,
            data.teamId,
            'Edit team membership',
            data.organizationId,
          ]);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  getTeamDetailsPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getTeamsDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.teamDetailsPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'Id',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteTeamsTeamMembership.next([data]);
      } else {
      }
    });
  }
}
